import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { AuthenticationService } from "../../../core/authentication/authentication.service";
import { DataTable } from "../../../shared/components/data-table/data-table.type";
import { UserInfo } from "../../../shared/types/user-info";
import { Contract } from "./contract.type";
import { ContractTableService } from "./contract-table.service";

@Component({
  selector: "app-contracts",
  templateUrl: "./contract.component.html",
  styleUrls: ["./contract.component.scss"],
})
export class ContractsComponent implements OnInit {
  currentUser: UserInfo;
  tableConfig: DataTable<Contract>;

  constructor(
    public contractTableService: ContractTableService,
    private router: Router,
    private authenticationService: AuthenticationService,
  ) {
    this.currentUser = this.authenticationService.currentUserInfo;
  }

  // #region Lifecycle Methods

  ngOnInit(): void {
    this.tableConfig = this.contractTableService.getContractsTableConfig();
  }

  // #endregion

  // #region Handlers

  onAddContract = (): void => this.addContract();

  // #endregion

  // #region Private Methods

  private addContract = (): void => {
    this.router.navigate(["/contracts/create"]);
  };

  // #endregion
}
